// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");

var maxWidthMainContent = CssJs.rem(100);

var maxWidthMainContentScreen = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.rem(100));

var margin = CssJs.margin("auto");

var rules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [margin]);

var blockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("S"));

exports.maxWidthMainContent = maxWidthMainContent;
exports.maxWidthMainContentScreen = maxWidthMainContentScreen;
exports.margin = margin;
exports.rules = rules;
exports.blockSpace = blockSpace;
/* maxWidthMainContent Not a pure module */
